import React, { ReactElement, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import emailIcon from './../../assets/images/message.svg';
import facebookIcon from './../../assets/images/facebook.svg';
import instagramIcon from './../../assets/images/instagram.svg';
import twitterIcon from './../../assets/images/twitter.svg';
import { globalSlice } from '../../redux/globalSlice';
import './CustomerCare.css';

type socialLinkType = {
  link: string;
  type: string;
  text: string;
  icon: string;
}

const socialLinks: socialLinkType[] = [
  {
    link: 'https://facebook.com/maxfashions',
    type: 'Facebook',
    text: 'Facebook.com/maxfashions',
    icon: facebookIcon
  },
  {
    link: 'https://twitter.com/maxfashionindia',
    type: 'Twitter',
    text: 'Twitter.com/maxfashionindia',
    icon: twitterIcon
  },
  {
    link: 'https://instagram.com/maxfashionindia',
    type: 'Instagram',
    text: 'Instagram.com/maxfashionindia',
    icon: instagramIcon
  }
]

const CustomerCare = (): ReactElement => {  
  const dispatch = useDispatch();

  useEffect(() => {
    const {setAppBarTitle, setBackNavEnabled} = globalSlice.actions;
    dispatch(setAppBarTitle('Customer care'));
    dispatch(setBackNavEnabled(true));
  }, []);

  const renderSocialLinks = () => {
    return socialLinks.map(socialLink => {
      return (
        <div key={socialLink.type} className="p-4 bg-white rounded-xl shadow-xl text-sm care-card">
          <Link to={{pathname: `${socialLink.link}`}} target="_blank" className="flex items-center">
            <img src={socialLink.icon} alt={socialLink.type} className="care-icons" />
            <span className="inline-block ml-2 break-all">{socialLink.text}</span>
          </Link>
        </div>
      )
    })
  }

  return (
    <div className="bg-light_purple pt-4 pb-2 px-8 border border-very_light_pink min-h-full">
      <header className="text-center">
        <div className="text-2xl font-medium care-title">Get in touch with us</div>
        <div className="mt-3 text-2xl text-alizarian_red care-phone-number">
          <a href="tel:1800 123 1555">1800-123-1555</a>
        </div>
        <div className="mt-2 text-brownish_grey text-base care-time">
          Mon to Sun, 10:00AM to 10:00PM
        </div>
      </header>
      <div className="grid grid-cols-1 gap-4 mt-5 care-cards-container">
        <div className="p-4 bg-white rounded-xl shadow-xl text-sm care-card">
          <a href="mailto:help.in@maxfashion.com" className="flex items-center">
            <img src={emailIcon} alt="Email" className="care-icons"/>
            <span className="inline-block ml-2 break-all">help.in@maxfashion.com</span>
          </a>
        </div>
        {renderSocialLinks()}      
      </div>
      <div className="text-center text-brownish_grey text-xs mt-6 care-copyright">(C) 2020 RNA Intellectual Property Limited</div>
    </div>
  );
};
export default CustomerCare;
